import HtmlRenderContainer from '@/components/content-management/html-render-container';

export default {
  name  : 'QuizFeedback',
  props : {
    question: {
      type    : Object,
      default : () => ({})
    },
    option: {
      type    : Object,
      default : () => ({})
    },
    shouldShowOptionFeedbackText: {
      type    : Boolean,
      default : false
    },
    hasFeedbackByOption: {
      type    : Boolean,
      default : false
    },
    hasFeedbackByQuestion: {
      type    : Boolean,
      default : false
    },
    shouldShowOptionFeedbackStatus: {
      type    : Boolean,
      default : false
    },
    optionStatusText: {
      type    : String,
      default : ''
    },
    isOptionCorrect: {
      type    : Boolean,
      default : false
    }
  },
  components: {
    HtmlRenderContainer
  }
};
